<template>
  <div>
    <bread-crumb path="内容管理" subPath="音视频分类列表"></bread-crumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加分类</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
        <el-table-column label="名称" align="center">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            {{scope.row.type | getTypeTitle(typeList)}}
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic_url" :src="scope.row.pic_url + '?imageView2/0/h/50'" class="list_img"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="intro" label="简介" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-card>
    <media-category-add
      :visible="addDialogAvaible"
      :id="currentId"
      :typeList="typeList"
      @add="addMediaCategory"
      @update="updateMediaCategory"
      @closeDialog="closeAddDialog">
    </media-category-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import MediaCategoryAdd from './MediaCategoryAdd.vue'

export default {
  name: 'media_category_list',
  components: {
    'bread-crumb': BreadCrumb,
    'media-category-add': MediaCategoryAdd
  },
  created () {
    this.param.news_index = process.env.VUE_APP_NEWS_INDEX
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      list: [],
      addDialogAvaible: false,
      total: 0,
      pageTotal: 1,
      param: {
        news_index: 1,
        page: 1,
        count: 10
      },
      typeList: [
        { id: 1, title: '音频' },
        { id: 2, title: '视频' }
      ]
    }
  },
  filters: {
    getTypeTitle (id, typeList) {
      for (var i = 0; i < typeList.length; i++) {
        if (typeList[i].id === id) {
          return typeList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/media_category/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async addMediaCategory (data) {
      const res = await this.$http.post('/admin/media_category/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateMediaCategory (id, data) {
      const res = await this.$http.post('/admin/media_category/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/media_category/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
